import { IGoogleMapsMarker } from "@app/interfaces/IGoogleMapsMarkerOptions";
import { IJourney } from "@app/interfaces/IJourney";
import { IPlot } from "@app/interfaces/IPlot";
import * as angular from "angular";
import { IVeriMapComponent } from "../veriMapComponent/veriMap.component";
import './veriMapContainer.component.scss';

class VeriMapContainerComponentController implements angular.IComponentController {
    locationMarker: IGoogleMapsMarker;
    plots: IPlot[];
    journeys: IJourney[];
    hideGeofences: boolean;
    selectedPlot: IPlot;
    veriMap: IVeriMapComponent;
    mapCenter: any;

    static $inject = ["$scope"];

    constructor(private readonly $scope: angular.IScope) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.$scope.$applyAsync();
    }

    mapIdle(veriMap: IVeriMapComponent): void {
        this.veriMap = veriMap;
    }
}

export class VeriMapContainerComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };
    constructor() {
        this.bindings = {
            hideGeofences: '<',
            journeys: '<',
            plots: '<',
            selectedPlot: '<',
            locationMarker: '<'
        };
        this.controller = VeriMapContainerComponentController;
        this.template = require("./veriMapContainer.component.html");
    }
}
